import "./Register.scss";
import { CustomLoadingButton, CustomLoadingGradient } from "../../components/ui/CustomButton";
import { MdCheckCircle } from "react-icons/md";
import newRequest from "../../utils/newRequest";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { validateEmail } from "../../utils/genericFunctions.js";
import { useTranslation } from "react-i18next";


const Register = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [tacError, setTacError] = useState("");
  const [showView, setShowView] = useState("register");
  const [emailSent, setEmailSent] = useState(false);
  const [registerTitle, setRegisterTitle] = useState("Register");
  const userAgent = navigator.userAgent;
  const [tacChecked, setTacChecked] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const paymentOptions = [
    { value: 'monthly', label: 'Monthly', desc: "Start growing your intermediary with efficiency" },
    { value: 'quarterly', label: 'Quarterly', desc: "Select quarter payment plan to get 10% off" },
    { value: 'annually', label: 'Annually', desc: "Select annual payment plan and get 20% off" },
  ];


  const planSelected = location.state;

  // console.log(`planSelected  ${JSON.stringify(planSelected, null, 2)}`);

  const fetchPlans = async () => {
    try {
      const res = await newRequest.get("/sub/findAll");
      setPlans(res.data);
      // set selected default plan to monthly
      setSelectedPayment({ value: 'monthly', label: 'Monthly', desc: "Start growing your intermediary" })
      // if plan has been selected, set as default
      if (planSelected) {
        setSelectedPlan(planSelected);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    fetchPlans();
  }, []);

  const handleTacChange = (event) => {
    setTacChecked(event.target.checked);
  };

  const handleRegister = async (e) => {
    // e.preventDefault();
    try {

      // console.log(`selectedPlan  ${JSON.stringify(selectedPlan, null, 2)}`);
      // console.log(`selectedPayment  ${JSON.stringify(selectedPayment, null, 2)}`);

      if (!selectedPlan) {
        setError("Please select your plan");
        return;
      }

      if (selectedPlan) {
        if (!selectedPayment) {
          setError("Please select payment option");
          return;
        }
      }

      if (!email) {
        setError("Please enter email");
        return;
      }

      if (!validateEmail(email)) {
        setError("Please valid email");
        return;
      }

      if (!tacChecked) {
        setTacError("You must agree to Terms and Conditions");
        return;
      }

      if (registerTitle === "Register") {
        setRegisterTitle("Please Wait...");
        // create signup record
        const resSignup = await newRequest.post("/q/signup", {
          su_email: email,
          su_plan: selectedPlan.sub_code,
          su_payment_freq: "monthly"
        });

        // console.log(`resSignup  ${JSON.stringify(resSignup.data, null, 2)}`);

        if (resSignup.data.status === "success") {
          const verificationLink = `https://bima-essentials.com/signup/${resSignup?.data?._id}`;

          // send email
          await newRequest.post("/email/signup", {
            to: email,
            subject: "Verify your email - Bima Essentials",
            plan_name: selectedPlan.sub_name,
            signup_docid: resSignup.data?.signup_id,
          });

          // console.log(`resEmail  ${JSON.stringify(resEmail.data, null, 2)}`);
          setShowView("emailSent");
        } else {
          setError(resSignup.data[0].text);
          return;
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setRegisterTitle("Register");
    }
  };


  return (
    <div className="register">
      {showView === "register" &&
        <motion.div
          className="wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h1 className="title">{t('register').toUpperCase()}</h1>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                try {
                  navigate("/bima");
                } catch (error) {
                  console.log(error)
                }
              }}
            >
              {t('appName')}
            </span>
          </div>
          <div className="pricing">
            <h1>{planSelected?.sub_name}</h1>
            <div className="pricing-cards-container">
              <div
                key={planSelected?._id}
                className="single-pricing-card active"
              >
                {planSelected?.sub_flag_show === "Y" && (
                  <div className="flag">{planSelected?.sub_flag_text}</div>
                )}

                <span className="plan-name">{planSelected?.sub_name}</span>

                <div className="plan-price-wrapper">
                  {selectedPayment?.value === "monthly" && (
                    <span className="price">{planSelected?.fmt_monthly_price_show}</span>
                  )}
                  {selectedPayment?.value === "quarterly" && (
                    <span className="price">{planSelected?.fmt_quater_price_show}</span>
                  )}
                  {selectedPayment?.value === "annually" && (
                    <span className="price">{planSelected?.fmt_annual_price_show}</span>
                  )}
                  <div className="price-details">
                    <span className="decimals">.00</span>
                    <span className="freq">
                      {planSelected?.sub_monthly_price > 0 ? `${selectedPayment?.value}` : "free"}
                    </span>
                  </div>
                </div>

                <div className="target-wrapper">
                  <span className="target">{planSelected?.sub_target}</span>
                </div>

                <div className="features-wrapper">
                  {planSelected?.sub_features?.map((feature) => (
                    <span key={feature._id} className="single-feature">
                      <MdCheckCircle className="custom-check active" />
                      {feature.feature_title}
                    </span>
                  ))}
                </div>

                <div className="purpose-wrapper">
                  <span className="purpose">{planSelected?.sub_purpose}</span>
                </div>
              </div>
            </div>
          </div>

          <form>
            <div className="input-item-with-label">
              <input
                id="email"
                name="email"
                type="email"
                placeholder="YOUR EMAIL"
                value={email}
                className="form-input-item"
                style={{ width: "400px", height: "40px" }}
                onChange={(e) => {
                  try {
                    setError("");
                    setEmail(e.target.value);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              />
            </div>
            {error && <div className="error" dangerouslySetInnerHTML={{ __html: error }} />}
            {/* Terms and Conditions */}
            <FormControl component="fieldset">
              {/* <FormLabel component="legend">Terms and Conditions</FormLabel> */}
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tacChecked}
                      onChange={handleTacChange}
                      style={{ color: "#7B1FA2" }}
                    />
                  }
                  label={
                    <Typography>
                      By signing up, you are agreeing to{" "}
                      <a href="/tac" target="_blank" rel="noopener noreferrer">
                        Terms & Conditions
                      </a>
                      .
                    </Typography>
                  }
                />
              </FormGroup>
            </FormControl>
            {tacError && <div className="error" dangerouslySetInnerHTML={{ __html: tacError }} />}
            <CustomLoadingButton
              currentTheme={currentTheme}
              height={"45px"}
              width={"350px"}
              onClick={handleRegister}
            >
              {registerTitle}
            </CustomLoadingButton>
          </form>
        </motion.div>}
      {showView === "emailSent" && (
        <motion.div
          className="wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <motion.div
            className="hero-text"
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
            }}
          >
            <h1>Great!</h1>
            <p dangerouslySetInnerHTML={{ __html: `We have sent an email to <strong>${email}</strong>. Please click on the verify button to finish signup process. The link will <strong>expire in 60 minutes</strong> after which you will be required to signup again.` }} />
            <CustomLoadingButton
              height={"45px"}
              width={"200px"}
              onClick={() => {
                try {
                  setEmail("");
                  setError("");
                  setTacError("");
                  setEmailSent(false);
                  navigate("/bima")
                } catch (error) {
                  console.log(error);
                }
              }}
            >
              CLICK HERE
            </CustomLoadingButton>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};



export default Register;
